import { ModalContainer } from "components/ui/display/ModalContainer"
import { Input } from "components/ui/inputs/Input";
import { useState } from "react";

export const CreateNewFolderModal = ({onSubmit, onDiscard}) => {

    const [newFolderName, setNewFolderName] = useState('');

    return (
        <ModalContainer
            title="Ny mappe"
            description="Opprett ny inndeling for egne notater."
            submitText="Opprett mappe"
            discardText="Forkast"
            onSubmit={() => onSubmit(newFolderName)}
            onDiscard={onDiscard}
        >
            <Input
                title="Navn på ny mappe"
                placeholder="Mappenavn..."
                value={newFolderName}
                onChange={(e) => setNewFolderName(e.target.value)}
            />
            
        </ModalContainer>
    )
}